import {create} from 'zustand';
import {NewAppointmentModalStore} from './types';

export const useNewAppointmentModalStore = create<NewAppointmentModalStore>(set => ({
	newAppointmentModal: false,
	setNewAppointmentModal: value => set({newAppointmentModal: value}),
}));
